export interface SwatchColor {
  name: string;
  background: string;
  color: string;
}

export const SWATCH_COLORS: SwatchColor[] = [
  // RED
  { name: "badge-polaris-01-01-red", background: "#FFFAFB", color: "#FED1D7" },
  { name: "badge-polaris-01-02-red", background: "#FFF6F8", color: "#FEC1C7" },
  { name: "badge-polaris-01-03-red", background: "#FFECEF", color: "#FDACB1" },
  { name: "badge-polaris-01-04-red", background: "#FEE8EB", color: "#F78086" },
  { name: "badge-polaris-01-05-red", background: "#FEE1E6", color: "#E22C38" },
  { name: "badge-polaris-01-06-red", background: "#FED9DF", color: "#C70A24" },
  { name: "badge-polaris-01-07-red", background: "#FED1D7", color: "#A30A24" },
  { name: "badge-polaris-01-08-red", background: "#FEC1C7", color: "#8E0B21" },
  { name: "badge-polaris-01-09-red", background: "#FDACB1", color: "#5F0716" },
  { name: "badge-polaris-01-10-red", background: "#F78086", color: "#2F040B" },
  { name: "badge-polaris-01-11-red", background: "#E22C38", color: "#FEE1E6" },
  { name: "badge-polaris-01-12-red", background: "#C70A24", color: "#FED9DF" },
  { name: "badge-polaris-01-13-red", background: "#A30A24", color: "#FED1D7" },
  { name: "badge-polaris-01-14-red", background: "#8E0B21", color: "#FEC1C7" },
  { name: "badge-polaris-01-15-red", background: "#5F0716", color: "#FDACB1" },
  { name: "badge-polaris-01-16-red", background: "#2F040B", color: "#F78086" },

  // ORANGE
  {
    name: "badge-polaris-02-01-orange",
    background: "#FFFDFA",
    color: "#FFD6A4",
  },
  {
    name: "badge-polaris-02-02-orange",
    background: "#FFF7EE",
    color: "#FFC879",
  },
  {
    name: "badge-polaris-02-03-orange",
    background: "#FFF1E3",
    color: "#FFB800",
  },
  {
    name: "badge-polaris-02-04-orange",
    background: "#FFEBD5",
    color: "#E5A500",
  },
  {
    name: "badge-polaris-02-05-orange",
    background: "#FFE4C6",
    color: "#B28400",
  },
  {
    name: "badge-polaris-02-06-orange",
    background: "#FFDDB6",
    color: "#956F00",
  },
  {
    name: "badge-polaris-02-07-orange",
    background: "#FFD6A4",
    color: "#7C5800",
  },
  {
    name: "badge-polaris-02-08-orange",
    background: "#FFC879",
    color: "#5E4200",
  },
  {
    name: "badge-polaris-02-09-orange",
    background: "#FFB800",
    color: "#412D00",
  },
  {
    name: "badge-polaris-02-10-orange",
    background: "#E5A500",
    color: "#251A00",
  },
  {
    name: "badge-polaris-02-11-orange",
    background: "#B28400",
    color: "#FFE4C6",
  },
  {
    name: "badge-polaris-02-12-orange",
    background: "#956F00",
    color: "#FFDDB6",
  },
  {
    name: "badge-polaris-02-13-orange",
    background: "#7C5800",
    color: "#FFD6A4",
  },
  {
    name: "badge-polaris-02-14-orange",
    background: "#5E4200",
    color: "#FFC879",
  },
  {
    name: "badge-polaris-02-15-orange",
    background: "#412D00",
    color: "#FFB800",
  },
  {
    name: "badge-polaris-02-16-orange",
    background: "#251A00",
    color: "#E5A500",
  },

  // YELLOW
  {
    name: "badge-polaris-03-01-yellow",
    background: "#FFFDF6",
    color: "#F7DF00",
  },
  {
    name: "badge-polaris-03-02-yellow",
    background: "#FFF8DB",
    color: "#EAD300",
  },
  {
    name: "badge-polaris-03-03-yellow",
    background: "#FFF4BF",
    color: "#E1CB00",
  },
  {
    name: "badge-polaris-03-04-yellow",
    background: "#FFEF9D",
    color: "#C5B200",
  },
  {
    name: "badge-polaris-03-05-yellow",
    background: "#FFEB78",
    color: "#998A00",
  },
  {
    name: "badge-polaris-03-06-yellow",
    background: "#FFE600",
    color: "#827500",
  },
  {
    name: "badge-polaris-03-07-yellow",
    background: "#F7DF00",
    color: "#695F00",
  },
  {
    name: "badge-polaris-03-08-yellow",
    background: "#EAD300",
    color: "#4F4700",
  },
  {
    name: "badge-polaris-03-09-yellow",
    background: "#E1CB00",
    color: "#332E00",
  },
  {
    name: "badge-polaris-03-10-yellow",
    background: "#C5B200",
    color: "#1F1C00",
  },
  {
    name: "badge-polaris-03-11-yellow",
    background: "#998A00",
    color: "#FFEB78",
  },
  {
    name: "badge-polaris-03-12-yellow",
    background: "#827500",
    color: "#FFE600",
  },
  {
    name: "badge-polaris-03-13-yellow",
    background: "#695F00",
    color: "#F7DF00",
  },
  {
    name: "badge-polaris-03-14-yellow",
    background: "#4F4700",
    color: "#EAD300",
  },
  {
    name: "badge-polaris-03-15-yellow",
    background: "#332E00",
    color: "#E1CB00",
  },
  {
    name: "badge-polaris-03-16-yellow",
    background: "#1F1C00",
    color: "#C5B200",
  },

  // LIME
  { name: "badge-polaris-04-01-lime", background: "#FAFFFA", color: "#38FE3E" },
  { name: "badge-polaris-04-02-lime", background: "#E4FFE5", color: "#28F22F" },
  { name: "badge-polaris-04-03-lime", background: "#D0FFD1", color: "#25E82B" },
  { name: "badge-polaris-04-04-lime", background: "#BBFEBE", color: "#20CF27" },
  { name: "badge-polaris-04-05-lime", background: "#9DFEA0", color: "#18A81D" },
  { name: "badge-polaris-04-06-lime", background: "#77FE7A", color: "#118715" },
  { name: "badge-polaris-04-07-lime", background: "#38FE3E", color: "#0C710F" },
  { name: "badge-polaris-04-08-lime", background: "#28F22F", color: "#0B550D" },
  { name: "badge-polaris-04-09-lime", background: "#25E82B", color: "#033D05" },
  { name: "badge-polaris-04-10-lime", background: "#20CF27", color: "#032104" },
  { name: "badge-polaris-04-11-lime", background: "#18A81D", color: "#9DFEA0" },
  { name: "badge-polaris-04-12-lime", background: "#118715", color: "#77FE7A" },
  { name: "badge-polaris-04-13-lime", background: "#0C710F", color: "#38FE3E" },
  { name: "badge-polaris-04-14-lime", background: "#0B550D", color: "#28F22F" },
  { name: "badge-polaris-04-15-lime", background: "#033D05", color: "#25E82B" },
  { name: "badge-polaris-04-16-lime", background: "#032104", color: "#20CF27" },

  // GREEN
  {
    name: "badge-polaris-05-01-green",
    background: "#FAFFFB",
    color: "#52F490",
  },
  {
    name: "badge-polaris-05-02-green",
    background: "#E6FEEA",
    color: "#2CED83",
  },
  {
    name: "badge-polaris-05-03-green",
    background: "#CDFED4",
    color: "#11DF7B",
  },
  {
    name: "badge-polaris-05-04-green",
    background: "#AFFEBF",
    color: "#18BF79",
  },
  {
    name: "badge-polaris-05-05-green",
    background: "#92FCAC",
    color: "#0D9C6A",
  },
  {
    name: "badge-polaris-05-06-green",
    background: "#6EF799",
    color: "#047B5D",
  },
  {
    name: "badge-polaris-05-07-green",
    background: "#52F490",
    color: "#035E4C",
  },
  {
    name: "badge-polaris-05-08-green",
    background: "#2CED83",
    color: "#014B40",
  },
  {
    name: "badge-polaris-05-09-green",
    background: "#11DF7B",
    color: "#073630",
  },
  {
    name: "badge-polaris-05-10-green",
    background: "#18BF79",
    color: "#022622",
  },
  {
    name: "badge-polaris-05-11-green",
    background: "#0D9C6A",
    color: "#92FCAC",
  },
  {
    name: "badge-polaris-05-12-green",
    background: "#047B5D",
    color: "#6EF799",
  },
  {
    name: "badge-polaris-05-13-green",
    background: "#035E4C",
    color: "#52F490",
  },
  {
    name: "badge-polaris-05-14-green",
    background: "#014B40",
    color: "#2CED83",
  },
  {
    name: "badge-polaris-05-15-green",
    background: "#073630",
    color: "#11DF7B",
  },
  {
    name: "badge-polaris-05-16-green",
    background: "#022622",
    color: "#18BF79",
  },

  // CYAN
  { name: "badge-polaris-06-01-cyan", background: "#FAFFFE", color: "#92EDDE" },
  { name: "badge-polaris-06-02-cyan", background: "#E7FCF8", color: "#82E3D1" },
  { name: "badge-polaris-06-03-cyan", background: "#D7FBF3", color: "#74DBC8" },
  { name: "badge-polaris-06-04-cyan", background: "#C0F9EF", color: "#17C7A7" },
  { name: "badge-polaris-06-05-cyan", background: "#A5F7E9", color: "#13A389" },
  { name: "badge-polaris-06-06-cyan", background: "#90F4E3", color: "#0E8470" },
  { name: "badge-polaris-06-07-cyan", background: "#92EDDE", color: "#086B5A" },
  { name: "badge-polaris-06-08-cyan", background: "#82E3D1", color: "#095346" },
  { name: "badge-polaris-06-09-cyan", background: "#74DBC8", color: "#06382F" },
  { name: "badge-polaris-06-10-cyan", background: "#17C7A7", color: "#05241E" },
  { name: "badge-polaris-06-11-cyan", background: "#13A389", color: "#A5F7E9" },
  { name: "badge-polaris-06-12-cyan", background: "#0E8470", color: "#90F4E3" },
  { name: "badge-polaris-06-13-cyan", background: "#086B5A", color: "#92EDDE" },
  { name: "badge-polaris-06-14-cyan", background: "#095346", color: "#82E3D1" },
  { name: "badge-polaris-06-15-cyan", background: "#06382F", color: "#74DBC8" },
  { name: "badge-polaris-06-16-cyan", background: "#05241E", color: "#17C7A7" },

  // TEAL
  { name: "badge-polaris-07-01-teal", background: "#F8FFFE", color: "#70F0E5" },
  { name: "badge-polaris-07-02-teal", background: "#E8FCFA", color: "#5AE6DB" },
  { name: "badge-polaris-07-03-teal", background: "#D7FAF7", color: "#2CE0D4" },
  { name: "badge-polaris-07-04-teal", background: "#C3F7F2", color: "#1EC7BC" },
  { name: "badge-polaris-07-05-teal", background: "#AAF6EF", color: "#00A198" },
  { name: "badge-polaris-07-06-teal", background: "#89F5EC", color: "#12837C" },
  { name: "badge-polaris-07-07-teal", background: "#70F0E5", color: "#0C6A64" },
  { name: "badge-polaris-07-08-teal", background: "#5AE6DB", color: "#0C534F" },
  { name: "badge-polaris-07-09-teal", background: "#2CE0D4", color: "#033C39" },
  { name: "badge-polaris-07-10-teal", background: "#1EC7BC", color: "#062C29" },
  { name: "badge-polaris-07-11-teal", background: "#00A198", color: "#AAF6EF" },
  { name: "badge-polaris-07-12-teal", background: "#12837C", color: "#89F5EC" },
  { name: "badge-polaris-07-13-teal", background: "#0C6A64", color: "#70F0E5" },
  { name: "badge-polaris-07-14-teal", background: "#0C534F", color: "#5AE6DB" },
  { name: "badge-polaris-07-15-teal", background: "#033C39", color: "#2CE0D4" },
  { name: "badge-polaris-07-16-teal", background: "#062C29", color: "#1EC7BC" },

  // AZURE
  {
    name: "badge-polaris-08-01-azure",
    background: "#FBFDFF",
    color: "#C0E1FF",
  },
  {
    name: "badge-polaris-08-02-azure",
    background: "#F2F9FF",
    color: "#A8D8FF",
  },
  {
    name: "badge-polaris-08-03-azure",
    background: "#EAF4FF",
    color: "#91D0FF",
  },
  {
    name: "badge-polaris-08-04-azure",
    background: "#E0F0FF",
    color: "#51C0FF",
  },
  {
    name: "badge-polaris-08-05-azure",
    background: "#D5EBFF",
    color: "#0094D5",
  },
  {
    name: "badge-polaris-08-06-azure",
    background: "#CAE6FF",
    color: "#007CB4",
  },
  {
    name: "badge-polaris-08-07-azure",
    background: "#C0E1FF",
    color: "#00679B",
  },
  {
    name: "badge-polaris-08-08-azure",
    background: "#A8D8FF",
    color: "#00527C",
  },
  {
    name: "badge-polaris-08-09-azure",
    background: "#91D0FF",
    color: "#003A5A",
  },
  {
    name: "badge-polaris-08-10-azure",
    background: "#51C0FF",
    color: "#002133",
  },
  {
    name: "badge-polaris-08-11-azure",
    background: "#0094D5",
    color: "#D5EBFF",
  },
  {
    name: "badge-polaris-08-12-azure",
    background: "#007CB4",
    color: "#CAE6FF",
  },
  {
    name: "badge-polaris-08-13-azure",
    background: "#00679B",
    color: "#C0E1FF",
  },
  {
    name: "badge-polaris-08-14-azure",
    background: "#00527C",
    color: "#A8D8FF",
  },
  {
    name: "badge-polaris-08-15-azure",
    background: "#003A5A",
    color: "#91D0FF",
  },
  {
    name: "badge-polaris-08-16-azure",
    background: "#002133",
    color: "#51C0FF",
  },

  // BLUE
  { name: "badge-polaris-09-01-blue", background: "#FCFDFF", color: "#D5DCFF" },
  { name: "badge-polaris-09-02-blue", background: "#F6F8FF", color: "#C5D0FF" },
  { name: "badge-polaris-09-03-blue", background: "#F0F2FF", color: "#BAC7FF" },
  { name: "badge-polaris-09-04-blue", background: "#EAEDFF", color: "#97ADFF" },
  { name: "badge-polaris-09-05-blue", background: "#E2E7FF", color: "#4188FF" },
  { name: "badge-polaris-09-06-blue", background: "#DBE1FF", color: "#0071E9" },
  { name: "badge-polaris-09-07-blue", background: "#D5DCFF", color: "#005BD3" },
  { name: "badge-polaris-09-08-blue", background: "#C5D0FF", color: "#004299" },
  { name: "badge-polaris-09-09-blue", background: "#BAC7FF", color: "#002E6A" },
  { name: "badge-polaris-09-10-blue", background: "#97ADFF", color: "#001633" },
  { name: "badge-polaris-09-11-blue", background: "#4188FF", color: "#E2E7FF" },
  { name: "badge-polaris-09-12-blue", background: "#0071E9", color: "#DBE1FF" },
  { name: "badge-polaris-09-13-blue", background: "#005BD3", color: "#D5DCFF" },
  { name: "badge-polaris-09-14-blue", background: "#004299", color: "#C5D0FF" },
  { name: "badge-polaris-09-15-blue", background: "#002E6A", color: "#BAC7FF" },
  { name: "badge-polaris-09-16-blue", background: "#001633", color: "#97ADFF" },

  // PURPLE
  {
    name: "badge-polaris-10-01-purple",
    background: "#FDFDFF",
    color: "#DFD9FF",
  },
  {
    name: "badge-polaris-10-02-purple",
    background: "#F8F7FF",
    color: "#D4CCFF",
  },
  {
    name: "badge-polaris-10-03-purple",
    background: "#F3F1FF",
    color: "#C7BCFF",
  },
  {
    name: "badge-polaris-10-04-purple",
    background: "#EFECFF",
    color: "#AA95FF",
  },
  {
    name: "badge-polaris-10-05-purple",
    background: "#E9E5FF",
    color: "#9474FF",
  },
  {
    name: "badge-polaris-10-06-purple",
    background: "#E4DEFF",
    color: "#8051FF",
  },
  {
    name: "badge-polaris-10-07-purple",
    background: "#DFD9FF",
    color: "#7126FF",
  },
  {
    name: "badge-polaris-10-08-purple",
    background: "#D4CCFF",
    color: "#5700D1",
  },
  {
    name: "badge-polaris-10-09-purple",
    background: "#C7BCFF",
    color: "#3B0093",
  },
  {
    name: "badge-polaris-10-10-purple",
    background: "#AA95FF",
    color: "#1C004F",
  },
  {
    name: "badge-polaris-10-11-purple",
    background: "#9474FF",
    color: "#E9E5FF",
  },
  {
    name: "badge-polaris-10-12-purple",
    background: "#8051FF",
    color: "#E4DEFF",
  },
  {
    name: "badge-polaris-10-13-purple",
    background: "#7126FF",
    color: "#DFD9FF",
  },
  {
    name: "badge-polaris-10-14-purple",
    background: "#5700D1",
    color: "#D4CCFF",
  },
  {
    name: "badge-polaris-10-15-purple",
    background: "#3B0093",
    color: "#C7BCFF",
  },
  {
    name: "badge-polaris-10-16-purple",
    background: "#1C004F",
    color: "#AA95FF",
  },

  // MAGENTA
  {
    name: "badge-polaris-11-01-magenta",
    background: "#FFFDFF",
    color: "#FBCFFB",
  },
  {
    name: "badge-polaris-11-02-magenta",
    background: "#FFF5FF",
    color: "#F9BEF9",
  },
  {
    name: "badge-polaris-11-03-magenta",
    background: "#FDEFFD",
    color: "#F8B1F8",
  },
  {
    name: "badge-polaris-11-04-magenta",
    background: "#FEE7FE",
    color: "#F68DF6",
  },
  {
    name: "badge-polaris-11-05-magenta",
    background: "#FCDFFC",
    color: "#E156E1",
  },
  {
    name: "badge-polaris-11-06-magenta",
    background: "#FBD7FB",
    color: "#C530C5",
  },
  {
    name: "badge-polaris-11-07-magenta",
    background: "#FBCFFB",
    color: "#9F269F",
  },
  {
    name: "badge-polaris-11-08-magenta",
    background: "#F9BEF9",
    color: "#791A79",
  },
  {
    name: "badge-polaris-11-09-magenta",
    background: "#F8B1F8",
    color: "#561056",
  },
  {
    name: "badge-polaris-11-10-magenta",
    background: "#F68DF6",
    color: "#340634",
  },
  {
    name: "badge-polaris-11-11-magenta",
    background: "#E156E1",
    color: "#FCDFFC",
  },
  {
    name: "badge-polaris-11-12-magenta",
    background: "#C530C5",
    color: "#FBD7FB",
  },
  {
    name: "badge-polaris-11-13-magenta",
    background: "#9F269F",
    color: "#FBCFFB",
  },
  {
    name: "badge-polaris-11-14-magenta",
    background: "#791A79",
    color: "#F9BEF9",
  },
  {
    name: "badge-polaris-11-15-magenta",
    background: "#561056",
    color: "#F8B1F8",
  },
  {
    name: "badge-polaris-11-16-magenta",
    background: "#340634",
    color: "#F68DF6",
  },

  // ROSE
  { name: "badge-polaris-12-01-rose", background: "#FFFDFD", color: "#FED1DD" },
  { name: "badge-polaris-12-02-rose", background: "#FFF6F8", color: "#FEC1D2" },
  { name: "badge-polaris-12-03-rose", background: "#FFEFF3", color: "#FEB5CA" },
  { name: "badge-polaris-12-04-rose", background: "#FFE8EE", color: "#FE8EB1" },
  { name: "badge-polaris-12-05-rose", background: "#FFE1E8", color: "#FD4B92" },
  { name: "badge-polaris-12-06-rose", background: "#FFD9E3", color: "#E30C76" },
  { name: "badge-polaris-12-07-rose", background: "#FED1DD", color: "#B9075F" },
  { name: "badge-polaris-12-08-rose", background: "#FEC1D2", color: "#8D0448" },
  { name: "badge-polaris-12-09-rose", background: "#FEB5CA", color: "#640231" },
  { name: "badge-polaris-12-10-rose", background: "#FE8EB1", color: "#3E011C" },
  { name: "badge-polaris-12-11-rose", background: "#FD4B92", color: "#FFE1E8" },
  { name: "badge-polaris-12-12-rose", background: "#E30C76", color: "#FFD9E3" },
  { name: "badge-polaris-12-13-rose", background: "#B9075F", color: "#FED1DD" },
  { name: "badge-polaris-12-14-rose", background: "#8D0448", color: "#FEC1D2" },
  { name: "badge-polaris-12-15-rose", background: "#640231", color: "#FEB5CA" },
  { name: "badge-polaris-12-16-rose", background: "#3E011C", color: "#FE8EB1" },
];

export function getSwatchByName(name: string): SwatchColor | undefined {
  return SWATCH_COLORS.find((swatch) => swatch.name === name);
}

export function getBackgroundByName(name: string): string {
  return getSwatchByName(name)?.background || "#fff";
}

export function getTextColorByName(name: string): string {
  return getSwatchByName(name)?.color || "#000";
}
